export default __webpack_public_path__ + "static/media/V_Forms.8d08dcb8.png";